<template>
  <div class="examine-box">
    <!-- 进度条 -->
    <fLow-progress :currentIndex="currentIndex"
      :maxIndex="maxIndex"
      :total="total"
      @on-previou="onPreviou"></fLow-progress>
    <!-- 答题 -->
    <div class="question-contianer">
      <div v-html="questionInfo.titleHtml"
        class="title"
        :class="{'hint':answerInfo.subType === 5}">
      </div>
      <div v-for="item of questionInfo.question"
        @click="onChoose(item)"
        :key="item.subCode"
        class="answer-box"
        :class="{'active': isAnswer(item.subCode)}">
        <div class="answer-text">{{item.subTitle}}</div>
        <div class="checked"></div>
      </div>
      <div v-html="questionInfo.suggestHtml"
        class="hint-box">
      </div>
    </div>
    <!-- 下一步 -->
    <div @click="onNext"
      class="btn-next-box">
      <div class="btn-next">{{isLast?'提交':'下一题'}}</div>
    </div>
    <!-- <img @click="onNext"
      class="btn-next"
      src="../../assets/interest/examine/btn_next.png"> -->
  </div>
</template>

<script>
import FLowProgress from './components/FLowProgress'
import { actions, injectMixins } from '@/services'
import { setupShence } from '@/helpers'
import coreUtil from '@/utils/core'

export default {
  components: { FLowProgress },
  mixins: [injectMixins],
  data () {
    return {
      questionList: [], // 问题列表
      questionInfo: {}, // 当前题目信息
      answerList: [], // 答案列表
      answerInfo: {
        answer: []
      }, // 答案信息
      time: 0, // 答题计时
      currentIndex: 0, // 当前题目索引
      maxIndex: 0, // 最大做题索引
      total: 0 // 题目总数
    }
  },
  async created () {
    const title = coreUtil.getLocal('wechat-title')
    document.title = title
    // 神策初始化
    await setupShence()
    // 获取题目
    this.getChatQuestions()
    // 开始计时
    setInterval(() => {
      this.time++
    }, 1000)
  },
  computed: {
    // 是否最后一题
    isLast () {
      return this.currentIndex === this.total - 1
    }
  },
  methods: {
    // 获取题目
    async getChatQuestions () {
      const params = { cpCode: this.cpCode, type: 1 }
      this.pageLoading = true
      const data = await this.gActions.getChatQuestions(params)
      this.pageLoading = false
      if (data) {
        this.questionList = data
        this.questionInfo = this.questionList[0]
        this.total = this.questionList.length
        // 答案初始化
        this.answerInit()
      } else {
        await this.$nextTick()
        this.$toast.error('题目获取失败')
      }
    },
    // 答案初始化
    answerInit () {
      const questionList = this.questionList
      const answerList = questionList.map(item => {
        item.answer = [{ subCode: item.code, subAnswer: '' }]
        return item
      })
      this.answerInfo = { ...answerList[0] }
      this.answerList = answerList
    },
    // 提交答案
    async save () {
      let params = {
        cpCode: this.cpCode,
        content: this.answerList,
        timeLength: this.time
      }
      if (this.isPreview) {
        params.isPreview = true
      }
      this.$toast.text('结果评测中...', 'default')
      const ret = await actions.assessuserAnswer(params)
      this.$toast.hide()
      if (ret) {
        // 如果是预览则缓存数据结果
        if (this.isPreview) {
          coreUtil.setLocal(`result-code-${this.code}`, ret)
        }
        // 清空海报缓存
        coreUtil.rmLocal(`posterImg-code-${this.code}`)
        const query = this.$route.query
        this.$router.push({ path: '/interest/result', query })
      } else {
        await this.$nextTick()
        this.$toast.text('提交失败')
      }
    },
    // 答案选择
    onChoose (row) {
      const { code, subType } = this.questionInfo
      let answer = this.answerInfo.answer
      const answerIndex = answer.findIndex(item => row.subCode === item.subAnswer)
      if (answerIndex >= 0) { // 当前答案已经存在则删除该答案
        answer.splice(answerIndex, 1)
      } else { // 修改答案信息
        const answerObj = { subCode: code, subAnswer: row.subCode }
        // 添加答案
        if (subType === 2) { // 单选
          answer = [answerObj]
        } else if (subType === 3) { // 多选
          answer.push(answerObj)
          answer = coreUtil.distinct(answer, 'subAnswer') // 去重
        }
      }
      // 清空该题之后的所有preCode和nextCode
      this.questionList.forEach((item, index) => {
        if (index > this.currentIndex) {
          item.preCode = 0
          item.nextCode = 0
        }
      })
      // 跳题code
      this.questionInfo.nextCode = row.nextCode
      // 保存答案
      this.answerInfo.answer = answer
      // 添加答案至答案列表
      this.answerList[this.currentIndex] = { ...this.answerInfo }
    },
    // 上一题
    onPreviou () {
      // 是否跳题
      const preCode = this.questionInfo.preCode
      if (preCode) { // 跳题
        this.jumpQuestion('preCode')
      } else { // 正常上一题
        this.currentIndex--
      }
      // 题目信息变更
      this.questionInfo = this.questionList[this.currentIndex]
      // 答案信息变更
      const answer = this.answerList[this.currentIndex]
      this.answerInfo = { ...answer }
    },
    // 下一步
    onNext () {
      // 判断是否需要选择答案
      let state = this.judgeAnswer()
      if (!state) {
        return
      }
      // 判断是否为最后一题(提交答案)
      if (this.isLast) {
        this.save()
        return
      }
      // 是否跳题
      const nextCode = this.questionInfo.nextCode
      if (nextCode) { // 跳题
        this.jumpQuestion('nextCode')
      } else { // 正常下一题
        this.currentIndex++
      }
      if (this.currentIndex >= this.maxIndex) {
        this.maxIndex = this.currentIndex
      }
      // 题目信息变更
      this.questionInfo = this.questionList[this.currentIndex]
      // 答案信息变更
      let answerInfo = this.answerList[this.currentIndex]
      if (answerInfo) {
        this.answerInfo = { ...answerInfo }
      }
    },
    // 跳题
    jumpQuestion (type) {
      const code = this.questionInfo[type]
      // 需要跳转题目的索引
      const index = this.questionList.findIndex(item => item.code === code)
      if (index >= 0) {
        this.currentIndex = index
        this.questionList[index].preCode = this.questionInfo.code
      }
    },
    // 判断是否需要选择答案
    judgeAnswer () {
      const answerInfo = this.answerList[this.currentIndex]
      // 提示语不需要选择答案
      if (answerInfo.subType === 5) {
        return true
      }
      // 判断是否选择答案
      const answer = answerInfo.answer
      const isAnswer = answer.some(item => item.subAnswer)
      if (!isAnswer) {
        this.$toast.text('请选择答案')
        return false
      }
      return true
    },
    // 是否为正确答案
    isAnswer (subCode) {
      const list = this.answerInfo.answer.map(item => item.subAnswer)
      return list.includes(subCode)
    }
  }
}

</script>

<style lang="scss">
@import "@/styles/variable.scss";

.examine-box {
  background: url("../../assets/interest/examine/bg_examine.png") no-repeat;
  background-size: cover;
  box-sizing: border-box;
  color: $mine-shaft;
  margin: 0;
  min-height: 100vh;
  padding: 25px 15px 0;
  .question-contianer {
    padding-bottom: 65px;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    padding: 32px 0;
    &.hint {
      color: $gray;
      font-size: 14px;
    }
    p,
    span {
      background-color: transparent !important;
    }
  }
  .answer-box {
    background-color: rgba(61, 211, 203, 0.05);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 60px;
    padding: 0 15px 0 20px;
    &:active {
      opacity: 0.5;
    }
    &.active {
      background-color: rgba(80, 227, 194, 0.2);
      .answer-text {
        color: $turquoise;
      }
      .checked {
        background-image: url("../../assets/interest/examine/ic_checked_active.png");
        width: 26px;
      }
    }
    .answer-text {
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      padding-left: 5px;
    }
    .checked {
      background-image: url("../../assets/interest/examine/ic_checked.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 20px;
      width: 20px;
    }
  }
  .answer-box + .answer-box {
    margin-top: 15px;
  }
  .btn-next-box {
    background-color: $white;
    box-sizing: border-box;
    height: 60px;
    padding: 10px 20px 0;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    width: 100%;
    &:active {
      opacity: 0.5;
    }
    .btn-next {
      background-color: $turquoise;
      border-radius: 20px;
      color: $white;
      height: 40px;
      line-height: 40px;
    }
  }
  .hint-box {
    padding-top: 15px;
    img {
      width: 100%;
    }
  }
}
</style>
